import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  formatDistanceToNow,
  formatDistanceToNowStrict,
  isDate,
} from 'date-fns';
import { LanguageCodes } from '@app-shared/enums/language-codes.enum';
import { LanguageRepository } from '@app-core/state/language.repository';
import { dateFnLocaleMap } from 'src/app/initialization/locales-init';

@Pipe({
  standalone: true,
  name: 'timeDistance',
  pure: false,
})
export class TimeDistancePipe implements PipeTransform {
  private readonly languageRepo = inject(LanguageRepository);

  transform(value: string, strict = false): string {
    try {
      if (!value) return '';

      const date: Date = new Date(value);
      const savedLanguage: LanguageCodes =
        this.languageRepo.getActiveLanguageCodeOrDefaultCode();

      if (isDate(date)) {
        if (strict) {
          return formatDistanceToNowStrict(date, {
            addSuffix: true,
            locale: dateFnLocaleMap.get(savedLanguage),
          });
        } else {
          return formatDistanceToNow(date, {
            addSuffix: true,
            locale: dateFnLocaleMap.get(savedLanguage),
          });
        }
      } else {
        return '';
      }
    } catch {
      return '';
    }
  }
}
